import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { navItems } from './nav-data';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
    navData = navItems;
    activeSubmenu: string | null = null;

    /**
     * constructor
     */
    constructor(private router: Router) { }

    ngOnInit(): void {
        const currentUrl = this.router.url;

        // Show submenu if current route matches a child path
        if (currentUrl.startsWith('/loan-management/')) {
            this.activeSubmenu = 'Loan Management.';
        }
    }

    /**
     * check if the route is active
     */
    isActive(nav: any): boolean {
        const currentRoute = this.router.url;
        if (nav.title === 'Loan Management.') {
            return currentRoute.startsWith('/loan-management/');
        }

        if (nav.children) {
            return nav.children.some(child => currentRoute.includes(child.route));
        }

        return currentRoute === nav.route;
    }


    /**
     * Toggles submenu for loan management
     * @param title 
     */
    toggleSubmenu(title: string) {
        this.activeSubmenu = this.activeSubmenu === title ? null : title;
    }


    /**
     * Closes submenu
     */
    closeSubmenu() {
        this.activeSubmenu = null;
    }

}
